import { render, staticRenderFns } from "./IntegerReferenceInformationCardIndex.vue?vue&type=template&id=0d5833ba&"
import script from "./IntegerReferenceInformationCardIndex.vue?vue&type=script&lang=js&"
export * from "./IntegerReferenceInformationCardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports